export default __webpack_public_path__ + "static/media/jamillesacramentoo.4ac97457.jpg";